import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { ButtonComponent } from '../buttons/button/button.component';
import { Location } from '@angular/common';
import { AuthService } from '@shared/services';

@Component({
  selector: 'app-notfound',
	standalone: true,
	imports: [RouterModule, ButtonComponent],
	templateUrl: './notfound.component.html',
	styleUrl: './notfound.component.scss',
})
export class NotfoundComponent {
	readonly #location = inject(Location)
	readonly #router = inject(Router)
	readonly #activatedRoute = inject(ActivatedRoute)
	readonly #authService = inject(AuthService)

	returnBack: string = this.#activatedRoute.snapshot.data['returnBack'] || ''
	redirectTo: string = this.#activatedRoute.snapshot.data['redirectTo'] || ''
	buttonText = signal('')

	constructor() {
		this.redirectTo
			? this.buttonText.set(`Ir atrás - ${this.redirectTo}`)
			: this.buttonText.set('Ir atrás')
	}

	goBack(): void {
		this.#authService.setTenant(sessionStorage.getItem('tenant')!)
		this.returnBack ? this.#location.back() : this.#router.navigate([`/page/${this.#authService.getTenant()}/dashboard`])
	}
}
